/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryDetailResponseDtoRecreationalSubtypesItem = typeof InquiryDetailResponseDtoRecreationalSubtypesItem[keyof typeof InquiryDetailResponseDtoRecreationalSubtypesItem];


export const InquiryDetailResponseDtoRecreationalSubtypesItem = {
  COTTAGE: 'COTTAGE',
  GARDEN_COTTAGE: 'GARDEN_COTTAGE',
  APARTMENT: 'APARTMENT',
} as const;
